const type = 'SET_AGREEMENT_SUMMARY';

const setAgreementSummary = (data) => ({
  data,
  type,
});

export { type };
export default setAgreementSummary;
